export default "__VITE_ASSET__Bi2Y$aKq__"